import axios from "axios";
import { Constants } from "utils";
import {
  getLocalStorageBaseUrl,
  getLocalViewAs,
  getLocalStore,
} from "utils/localStorage";
import { logoutExpired } from "../pages/Logout/Logout";

const API = (function () {
  const params = { isFromPortal: true };

  const api = axios.create({ params });
  let isLoggingOut = false;

  function setBaseUrl(baseUrl) {
    if (baseUrl) api.defaults.baseURL = baseUrl;
  }

  function setToken(token) {
    const localToken = getLocalStore()?.token;
    const auth = token || localToken || "";
    api.defaults.headers.Authorization = `Bearer ${auth}`;
  }
  api.interceptors.request.use(function (request) {
    // check for careprovider credential
    const userLogin = localStorage.getItem("user-login-data");
    const currentLoggedUserData = localStorage.getItem("thriving/store");
    const parsedCurrentUserData = JSON.parse(currentLoggedUserData)
    const parseUserLogin = JSON.parse(userLogin);
    
    // is careprovider anonymize

    const getCareAdminFromCareHomeList = parseUserLogin?.careHomes?.filter((item) => item?.identifier === parsedCurrentUserData?.identifier)?.[0]

    const dashboardType = parseUserLogin?.dashboardType || parsedCurrentUserData?.dashboardType;
    const shouldAnonymize = parsedCurrentUserData?.shouldAnonymize || parseUserLogin?.shouldAnonymize || getCareAdminFromCareHomeList?.shouldAnonymize;

    const isAnonymizeRequired = (dashboardType === Constants?.dashboardRoles?.caregiver ||
        dashboardType === Constants?.dashboardRoles?.admin ) && shouldAnonymize;
      

    // add header for anonymize
    if (isAnonymizeRequired) {
      request.headers["shouldAnonymize"] = "true";
      request.headers["dashboardType"] = dashboardType;
    }
    // ===== Sub Admin Care Home headers =====
    const requesterId = localStorage.getItem("requesterId");

    if (requesterId) {
      request.headers["X-Requester-Id"] = requesterId;
    }

    return request;
  });
  // Interceptor for error codes
  api.interceptors.response.use(function (response) {
    const { data } = response;
    if (data?.code < 0) throw response;
    return response;
  },
    function (error) {
      const message = error?.response?.data?.message || "";
    const key = error?.response?.data?.key || "";
       // Session expired
    if (!isLoggingOut &&
      ( key === "error.invalid_token" || message.includes("JWT expired"))) {
      isLoggingOut = true;
      logoutExpired();

      // Stop the error from propagating
      return new Promise(() => {});
    }

      if ( error?.response?.data?.key ===
        "error.you_do_not_have_enough_acess") {
        localStorage.setItem(
          "accessDeniedWarning",
          JSON.stringify({
            message: "You do not have enough access.",
            timestamp: Date.now(),
          })
        );

        window.dispatchEvent(new Event("access-denied"));
        
      }

      return Promise.reject(error);
    });

  // View as query param to make requests as careHome
  function setViewAs() {
    const viewAs = getLocalViewAs();
    if (viewAs && viewAs?.identifier)
      api.defaults.params = {
        ...api.defaults.params,
        viewAs: viewAs.identifier,
      };
  }

  // Initial configuration calls
  setBaseUrl(getLocalStorageBaseUrl());
  // setBaseUrl(`http://192.168.1.46:8080/`);
  setToken();
  setViewAs();

  const multipartHeader = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  // REST methods

  const get = (url, config) => api.get(url, config);
  const post = (url, body, config) => api.post(url, body, config);
  const put = (url, body, config) => api.put(url, body, config);
  const del = (url, config) => api.delete(url, config);

  // with multipart header

  const postMultipart = (url, body, config) =>
    api.post(url, body, { ...config, ...multipartHeader });

  const putMultipart = (url, body, config) =>
    api.put(url, body, { ...config, ...multipartHeader });

  return {
    multipartHeader,
    setToken,
    setViewAs,
    setBaseUrl,
    // REST methods
    get,
    post,
    put,
    del,
    //
    postMultipart,
    putMultipart,
  };
})();

export default API;
